import './index.scss';
import {observer, inject} from 'mobx-react';
import ModuleTitle from '../ModuleTitle';
@inject(({store}) => ({
    sqdw: store.sqdw,
    jump: store.jump,
    ymbj: store.ymbj
}))
@observer
class SummerBaby extends React.Component {
    render() {
        const {sqdw, jump, ymbj} = this.props;
        if(!sqdw.length || (ymbj.sqdwbyc && ymbj.sqdwbyc.switch !== 1)) return null;
        return (
            <div className="m-summerbaby m-floor" id="sqdwbyc">
                <div className="sp-container">
                    <ModuleTitle name="sqdwbyc"/>
                    <div className="content">
                        {
                            sqdw.map((item, index) => {
                                if(index > 5) return null;
                                return(
                                    <div className="sp-item" onClick={() => {
                                        jump(item.jumpInfo, 'shuqi_topic');
                                        sendSk('click_topic' + (index + 1));
                                    }}>
                                        <img className="item-img" src={item.img} />
                                        <div className="sp-content">
                                            <div className="sp-tit"><span className="yo-ico g-ico">&#xe898;</span><span className="text">{item.flag}</span></div>
                                            <div className="sp-desc">
                                                <p className="sp-title">{item.title}</p>
                                                <p className="sp-text">{item.feature}<span className="yo-ico right-ico">&#xf07f;</span></p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default SummerBaby;